const image = {
    toolbar: {
        blur: '32px',
    },
};

export default image;
